module.exports = __webpack_public_path__ + "img/cancel.16b9273f.svg";